module.exports = __webpack_public_path__ + "static/img/NOTTINGHAM-MDF.430f529.png";


//////////////////
// WEBPACK FOOTER
// ./static/materials/cortina/NOTTINGHAM-MDF.png
// module id = QgwZ
// module chunks = 0